import { useState } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { PlayAnimated, playAnimation } from 'components/icons'
import dynamic from 'next/dynamic'
import { Typography } from 'common/typography'
import { SecondaryButton } from 'common/button'
import ContentRenderer from 'content-renderer'
import SecurePayment from 'course/video-card/secure-payment'

const VideoCardLazy = dynamic(
  () => import('../course/video-card-lazy'),
  {
    loading: () => (<div />),
  },
)


const LearningPlanVideoCardStyled = styled.div`
  display: none;
  width: 100%;
  max-inline-size: 384px;
  border-radius: 24px;
  overflow: hidden;
  height: fit-content;
  .content-container {
    padding: 24px;
    background: var(--neutral100);
    h6 {
      margin-block-end: 4px;
    }
    .card-description {
      margin-block-start: 4px;
      margin-block-end: 16px;
    }
  }
  .secure-payment {
    display: block;
  }
  .video-thumb {
    position: relative;
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .play-container {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    ${playAnimation}
  }
  @media(min-width: 1024px) {
    display: block;
    position: fixed;
  }
`

function LearningPlanVideoCard({ course }) {
  const [playing, setPlaying] = useState(false)

  const player_url = course?.featured_video?.player_url || 'https://player.vimeo.com/video/569115778'
  const thumbnail = course?.featured_video?.thumbnails[0]?.link || 'https://i.vimeocdn.com/video/1185290720-6ac9c284aa0c7532fd8572852937b32f1b535e9ede4775482ce077e16e72ca44-d_640x360?r=pad'

  return (
    <LearningPlanVideoCardStyled>
      {!playing
        ? (
          <div className="video-thumb" id="video-card-hover" onClick={() => setPlaying(true)}>
            <img
              width="436"
              height="244.5625"
              className="thumb"
              src={thumbnail}
              alt="thumbnail del video de la presentacion del curso"
            />
            <div className="play-container">
              <PlayAnimated width="60px" height="60px" color="white" />
            </div>
          </div>)
        : (
          <VideoCardLazy videoUrl={player_url} />
        )}
      <div className="content-container">
        {!course?.title ? (
          <>
            <Typography font="headline5" as="h6" color="var(--white)">
              Nuestro plan de estudio
            </Typography>
            <Typography className="card-description" color="var(--white)">
              De cero a Software Engineer
            </Typography>
            <Link href="/precios" passHref>
              <SecondaryButton fullWidth>
                Ver opciones de pago
              </SecondaryButton>
            </Link>
            <SecurePayment />
          </>
        ) : (
          <>
            <Typography font="headline5" as="h6" color="var(--white)">
              {course.title}
            </Typography>
            <ContentRenderer color="var(--white)" chunks={course?.summary.blocks.slice(0, 1)} font="p2Regular" />
            <Link href={`/cursos/${course.slug}`} passHref>
              <SecondaryButton fullWidth>
                Ver curso
              </SecondaryButton>
            </Link>
          </>
        )}
      </div>
    </LearningPlanVideoCardStyled>
  )
}

export default LearningPlanVideoCard
